/**
 * Converts an unknown error into an Error.
 */
export function toError(err: unknown): Error {
  let error: Error;
  if (err instanceof Error) {
    error = err;
  } else {
    error = new Error(getErrorMessage(err));
  }
  return error;
}

/**
 * Get the message from an error.
 */
export function getErrorMessage(err: unknown): string {
  if (err instanceof Error) {
    return err.message;
  } else if (err && typeof err === 'object' && typeof (err as any).message === 'string') {
    return (err as any).message;
  } else if (typeof err === 'string') {
    return err;
  } else if (!err || typeof err === 'number') {
    return '' + err;
  }
  let json = JSON.stringify(err);
  if (json.length > 80) {
    json = json.slice(0, 80) + '…';
  }
  return json;
}
